import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f28b4916"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex w-full align-items-center justify-content-between" }
const _hoisted_2 = { class: "flex justify-content-start align-items-center" }
const _hoisted_3 = {
  key: 0,
  class: "flex flex-column"
}
const _hoisted_4 = { class: "flex align-items-center" }
const _hoisted_5 = { class: "app-label-small text-gray-d1 mr-2 font-medium" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ci-icon-lock" }, null, -1))
const _hoisted_7 = {
  key: 0,
  class: "app-label-micro text-gray-l1"
}
const _hoisted_8 = {
  key: 1,
  class: "flex flex-column"
}
const _hoisted_9 = { class: "app-label-small text-gray-d1 font-medium" }
const _hoisted_10 = { class: "app-label-micro text-gray-l1" }
const _hoisted_11 = { key: 2 }
const _hoisted_12 = { class: "app-label-small text-gray-d1 font-medium" }
const _hoisted_13 = {
  key: 0,
  class: "chip"
}
const _hoisted_14 = { class: "app-label-micro text-white" }
const _hoisted_15 = {
  key: 1,
  class: "flex link-icon"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ci-arrows-right" }, null, -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = ["href"]
const _hoisted_19 = { class: "flex w-full align-items-center justify-content-between" }
const _hoisted_20 = { class: "flex justify-content-start align-items-center" }
const _hoisted_21 = {
  key: 0,
  class: "flex flex-column"
}
const _hoisted_22 = { class: "flex align-items-center" }
const _hoisted_23 = { class: "app-label-small text-gray-d1 mr-2 font-medium" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ci-icon-lock" }, null, -1))
const _hoisted_25 = {
  key: 0,
  class: "app-label-micro text-gray-l1"
}
const _hoisted_26 = {
  key: 1,
  class: "flex flex-column"
}
const _hoisted_27 = { class: "app-label-small text-gray-d1 font-medium" }
const _hoisted_28 = { class: "app-label-micro text-gray-l1" }
const _hoisted_29 = { key: 2 }
const _hoisted_30 = { class: "app-label-small text-gray-d1 font-medium" }
const _hoisted_31 = {
  key: 0,
  class: "chip"
}
const _hoisted_32 = { class: "app-abel-micro text-white" }
const _hoisted_33 = {
  key: 1,
  class: "flex link-icon"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ci-arrows-right" }, null, -1))
const _hoisted_35 = [
  _hoisted_34
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (subItem, j) => {
    return (_openBlock(), _createElementBlock("div", {
      key: subItem.label || j,
      class: "menu-link"
    }, [
      (subItem.to)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            onClick: _ctx.clickedItem,
            to: subItem.to,
            class: _normalizeClass([
        'flex align-items-center p-1',
        { 'p-disabled': subItem.disabled },
        subItem.secondaryLabel ? 'menu-h-35' : 'menu-h-30',
      ])
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("i", {
                    class: _normalizeClass(['mr-2', subItem.icon ? subItem.icon : 'ci-icon-layers'])
                  }, null, 2),
                  (subItem.locked)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                          _createElementVNode("span", _hoisted_5, _toDisplayString(subItem.label), 1),
                          _hoisted_6
                        ]),
                        (subItem.secondaryLabel)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(subItem.secondaryLabel), 1))
                          : _createCommentVNode("", true)
                      ]))
                    : (subItem.secondaryLabel && !subItem.locked)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          _createElementVNode("span", _hoisted_9, _toDisplayString(subItem.label), 1),
                          _createElementVNode("span", _hoisted_10, _toDisplayString(subItem.secondaryLabel), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _createElementVNode("span", _hoisted_12, _toDisplayString(subItem.label), 1)
                        ]))
                ]),
                (subItem.chipValue)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, _toDisplayString(subItem.chipValue), 1)
                    ]))
                  : _createCommentVNode("", true),
                (!subItem.chipValue)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_17))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 2
          }, 1032, ["onClick", "to", "class"]))
        : _createCommentVNode("", true),
      (!subItem.to)
        ? (_openBlock(), _createElementBlock("a", {
            key: 1,
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clickedItem && _ctx.clickedItem(...args))),
            href: subItem.url || '#',
            class: _normalizeClass([
        'flex align-items-center p-1',
        { 'p-disabled': subItem.disabled },
        subItem.secondaryLabel ? 'menu-h-35' : 'menu-h-30',
      ]),
            target: "_blank"
          }, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("i", {
                  class: _normalizeClass(['mr-2', subItem.icon ? subItem.icon : 'ci-icon-layers'])
                }, null, 2),
                (subItem.locked)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("span", _hoisted_23, _toDisplayString(subItem.label), 1),
                        _hoisted_24
                      ]),
                      (subItem.secondaryLabel)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(subItem.secondaryLabel), 1))
                        : _createCommentVNode("", true)
                    ]))
                  : (subItem.secondaryLabel && !subItem.locked)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                        _createElementVNode("span", _hoisted_27, _toDisplayString(subItem.label), 1),
                        _createElementVNode("span", _hoisted_28, _toDisplayString(subItem.secondaryLabel), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_29, [
                        _createElementVNode("span", _hoisted_30, _toDisplayString(subItem.label), 1)
                      ]))
              ]),
              (subItem.chipValue)
                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, _toDisplayString(subItem.chipValue), 1)
                  ]))
                : _createCommentVNode("", true),
              (!subItem.chipValue)
                ? (_openBlock(), _createElementBlock("div", _hoisted_33, _hoisted_35))
                : _createCommentVNode("", true)
            ])
          ], 10, _hoisted_18))
        : _createCommentVNode("", true)
    ]))
  }), 128))
}